import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { mapSessionData } from 'features/sessions/utils';

export const useSessionQuery = (sessionIdParam?: string | null) => {
  const { sessionId: sessionIdFromParams } = useParams();
  const { request } = useQueryHTTPRequest();

  const sessionId = sessionIdParam ?? sessionIdFromParams;

  return useQuery(
    [queryKeys.coachSession, sessionId],
    ({ signal }) =>
      request({ url: `/api/coach/coaching-sessions/${sessionId}`, signal }),
    {
      enabled: !!sessionId,
      select: (data) => mapSessionData(data),
      staleTime: 10 * 1000,
    }
  );
};
